import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a749b644"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "black-matte" }

interface Props {
  opacity?: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BlackMatte',
  props: {
    opacity: null
  },
  setup(__props: any) {

const props = __props as {
  opacity?: number
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "absolute top-0 left-0 w-full h-full bg-black pointer-events-none",
      style: _normalizeStyle({ opacity: props.opacity ? props.opacity : 1 })
    }, null, 4)
  ]))
}
}

})